import { getUiCopy } from "../i18n/copy";

export interface FeedbackCopy {
  prompt: string;
  ratingLabels: readonly string[];
}

export const getFeedbackCopy = (language?: string): FeedbackCopy => {
  const copy = getUiCopy(language);
  return {
    prompt: copy.feedbackPrompt,
    ratingLabels: copy.ratingLabels,
  };
};